import { apiTmx } from '@/services/api-config';

export default function () {
  const userLogged = sessionStorage.getItem('userLogged');
  const userParams = new URLSearchParams();

  if (userLogged) {
    userParams.append('grant_type', 'password');
    userParams.append('username', `${process.env.VUE_APP_USER_TMX}`);
    userParams.append('password', `${process.env.VUE_APP_PSW_TMX}`);
    userParams.append('client_id', 'ngAuthApp');
    userParams.append('language', 'pt-BR');
    userParams.append('dns', `${process.env.VUE_APP_DNS}`);
  }

  return apiTmx
    .post(
      'oauth/token',
      userParams,
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
    )
    .then((response) => {
      const token = `Bearer ${response.data.access_token}`;
      sessionStorage.setItem('chave', token);
      return token;
    })
    .catch((e) => console.log(e));
}
